import { render, staticRenderFns } from "./ReceptionDetailDiseaseEditor.vue?vue&type=template&id=65043610&scoped=true&"
import script from "./ReceptionDetailDiseaseEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailDiseaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailDiseaseEditor.vue?vue&type=style&index=0&id=65043610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65043610",
  null
  
)

export default component.exports